import memoizeOne from 'memoize-one';

import { invoiceGroupsStatus_get_byId_v1 } from '@atlassian/commerce-ccp-gateway-client';
import { getSuccessfulResultOrThrow } from '@atlassian/commerce-ccp-gateway-client/error-wrappers';

import { cfetch } from '@confluence/network';

import { getCurrentEntitlementDetails } from './getCurrentEntitlementDetails';

const memoizedInvoiceGroupStatus_get_byId_v1 = memoizeOne(
	invoiceGroupsStatus_get_byId_v1,
	(
		[
			{
				headers: { 'X-transaction-account': newTransactionAccountId },
			},
		],
		[
			{
				headers: { 'X-transaction-account': lastTransactionAccountId },
			},
		],
	) => {
		return newTransactionAccountId === lastTransactionAccountId;
	},
);

/**
 * Determines if a CCP tenant is invoiceable and therefore has billing information
 * Throws an error if there is an empty response
 */
export const ccpIsInvoiceable = async (): Promise<boolean> => {
	const { transactionAccountId, subscriptionv2 } = (await getCurrentEntitlementDetails()) ?? {};
	if (!transactionAccountId || !subscriptionv2?.accountDetails?.invoiceGroupId) return false;

	try {
		const invoiceGroupStatus = getSuccessfulResultOrThrow(
			await memoizedInvoiceGroupStatus_get_byId_v1({
				fetch: cfetch,
				headers: { 'X-transaction-account': transactionAccountId },
				pathParameters: { id: subscriptionv2.accountDetails.invoiceGroupId },
			}),
		);
		return invoiceGroupStatus?.invoiceable === true;
	} catch (error) {
		throw error;
	}
};

const cfetchBillingDetails = async (cloudId: string) => {
	const response = await cfetch(
		`/gateway/api/billing-ux/cloud/${cloudId}/billing/billing-details`,
		{
			method: 'GET',
			headers: {
				'Content-Type': 'application/json',
			},
		},
	);
	if (!response.ok) {
		throw new Error(`HTTP error ${response.status}`);
	}
	return await response.json();
};

const memoizedCfetchBillingDetails = memoizeOne(cfetchBillingDetails);

// paymentMethod enum values are: NO_DETAILS, TOKENIZED_CREDIT_CARD, TOKENIZED_STRIPE_CREDIT_CARD, PAYPAL_ACCOUNT
export const hamsHasPaymentMethod = async (cloudId: string) => {
	try {
		const { paymentMethod } = await memoizedCfetchBillingDetails(cloudId);
		return (paymentMethod && paymentMethod !== 'NO_DETAILS') || false;
	} catch (error) {
		throw error;
	}
};
